<template>
  <a-drawer width="55vw" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item :label="$t('账户类型.账户类型名称')" prop="categoryName">
        <a-input
          v-model="form.categoryName"
          :maxLength="50"
          :placeholder="$t('通用.输入.请输入') + $t('账户类型.账户类型名称')"
        />
      </a-form-model-item>

      <!--多语言集成-->
      <a-form-item
        v-if="form.localeList.length > 0"
        :label="this.$t('通用.文本.多语言配置')"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 20 }"
        class="margin-bottom-10"
      >
        <a-table :data-source="form.localeList" :columns="localeColumns" rowKey="id" :pagination="false" bordered>
          <span slot="locale" slot-scope="text, record">
            <custom-dict-tag :options="customDict.LocaleEnum" :value="record.locale" />
          </span>
          <div slot="name" slot-scope="text, record">
            <a-input
              v-model="record.name"
              :maxLength="16"
              :placeholder="$t('通用.输入.请输入') + $t('主营行业.分类名称')"
              @blur.native.capture="validatorLocaleName"
            />
          </div>
          <div slot="action" slot-scope="text, record">
            <a-button type="primary" @click="getTranslation(record)">
              {{ $t('通用.按钮.翻译') }}
            </a-button>
          </div>
        </a-table>
        <span style="color: red">{{ errorMessage }}</span>
      </a-form-item>
      <!--多语言集成-->

      <a-form-model-item :label="$t('通用.文本.排序')" prop="sort">
        <a-input-number
          :maxLength="6"
          style="width: 50%"
          @change="limitSort"
          v-model="form.sort"
          :placeholder="$t('通用.输入.请输入') + $t('通用.文本.排序')"
        />
      </a-form-model-item>

      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video
          style="width: 100%"
          :src="previewUrl"
          ref="myVideo"
          :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'"
          :controls="true"
        ></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('通用.按钮.保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('通用.按钮.取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getShopAccount, addShopAccount, updateShopAccount } from '@/api/shop/shopAccount'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { generateFilePath, uploadObject } from '@/api/tool/oss'
//多语言集成
import { translation } from '@/api/tool/common'
//多语言集成

export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag,
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        categoryName: null,

        categoryNameEn: null,

        categoryNameTc: null,

        sort: null,

        createTime: null,

        remark: null,
        // 多语言集成
        localeList: [],
        // 多语言集成
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        categoryName: [
          {
            required: true,
            message: this.$t('账户类型（店铺）.账户类型名称') + this.$t('通用.文本.不能为空'),
            trigger: 'blur',
          },
        ],
        categoryNameEn: [
          {
            required: true,
            message: this.$t('账户类型（店铺）.账户类型名称-英文') + this.$t('通用.文本.不能为空'),
            trigger: 'blur',
          },
        ],
        categoryNameTc: [
          {
            required: true,
            message: this.$t('账户类型（店铺）.账户类型名称-繁体') + this.$t('通用.文本.不能为空'),
            trigger: 'blur',
          },
        ],
      },
      //多语言集成
      errorMessage: undefined,
      localeColumns: [
        {
          title: this.$t('通用.文本.语言'),
          dataIndex: 'locale',
          key: 'locale',
          scopedSlots: { customRender: 'locale' },
        },
        {
          title: this.$t('主营行业.分类名称'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
          key: 'name',
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'action',
          key: 'action',
          slots: { title: 'addbtn', customRender: 'brandName' },
          scopedSlots: { customRender: 'action' },
        },
      ],
      //多语言集成
    }
  },
  filters: {},
  created() {},
  //多语言集成
  computed: {
    ...mapGetters(['customDict']),
  },
  //多语言集成
  watch: {},
  mounted() {},
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    previewVideoCancel() {
      this.previewVideoVisible = false
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        categoryName: null,
        categoryNameEn: null,
        categoryNameTc: null,
        sort: null,
        createTime: null,
        remark: null,
        //多语言集成
        localeList: [],
        //多语言集成
      }
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
      //多语言集成
      this.initLocale()
      //多语言集成
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getShopAccount({ id: id }).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateShopAccount(this.form)
              .then((response) => {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            message = this.$t('通用.文本.修改成功')
            addShopAccount(this.form)
              .then((response) => {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
    //多语言集成

    initLocale() {
      //获取全局配置的语言
      const sysLangList = globalThis.$openLangList
      //初始化多语言
      let localeList = []
      let i = 1
      this.customDict.LocaleEnum.forEach((e) => {
        if (sysLangList.includes(e.type)) {
          localeList.push({ id: i, locale: e.type, name: '' })
          i++
        }
      })
      this.form.localeList = localeList
    },
    validatorLocaleName() {
      let errorMessage = ''
      var localeList = this.form.localeList
      let localeEnum = this.customDict.LocaleEnum
      localeList.forEach((e) => {
        if (!e.name) {
          let localeName = localeEnum.find((locale) => locale.type === e.locale).name
          errorMessage += localeName + this.$t('通用.文本.不能为空') + ';'
        }
      })
      if (errorMessage) {
        this.errorMessage = errorMessage
        return false
      }
      this.errorMessage = ''
      return true
    },
    getTranslation(record) {
      if (!this.form.categoryName) {
        return
      }
      let data = { text: this.form.categoryName, locale: record.locale }
      translation(data).then((response) => {
        record.name = response.data
      })
    },
    limitSort(record) {
      // console.log(i);
      let val = record.sort.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1')
      if (val == null || val == undefined || val == '') {
        val = 0
      }
      if (val > 21474836) {
        val = 21474836
      }
      record.sort = val
    },
    //多语言集成
  },
}
</script>
